<template>
  <div class="main-wrapper">
    <div class="content-wrapper">
      <top-nav-section :menus="menus" :back-link="backLink" :display="showTopNav"></top-nav-section>

      <!-- View -->
      <slot></slot>

      <!-- Video player -->
      <video-player ref="videoPlayer" class="background" style="display:none;" :custom-control="false"></video-player>

      <!-- VR video and Image -->
      <!--<vr-player ref="vrPlayer"></vr-player>-->

      <!--<vr-pano ref="vrPano"></vr-pano>-->

      <!-- code to handle video play end -->
      <app-dash-gallery ref="gallery" style="height: 100%;width: 100%;"></app-dash-gallery>
      <app-dash-swiper ref="gallery"  v-if="false" style="height: 100%;width: 100%;"></app-dash-swiper>
    </div>
  </div>
</template>

<script>
  /* eslint-disable dot-notation */

  import '../../static/assets/js/scaling';
// eslint-disable-next-line object-curly-spacing
  import {EventBus} from '../assets/js/event-bus';
  import TopNavSection from './TheTopNavSection';
  import VideoPlayer from './Video-Player';
  import AppDashGallery from './Gallery';
  import AppDashSwiper from './Swiper';
  // import VrPlayer from './VR-Player-Aframe';
  // import VrPlayer from './VR-Pano-Vid';
  // import VrPano from './VR-PhotoSphereViewer';
  // import VrPlayerBabylon from './VR-Player-Babylon';

  export default {
    components: {
      AppDashSwiper,
      TopNavSection,
      AppDashGallery,
      VideoPlayer,
      // VrPlayer,
    },
    name: 'main-container',
    props: ['backLink', 'showTopNav'],
    mounted() {
      EventBus.$on('hoverable-clicked-event', this.handleHoverableClick);
      EventBus.$on('vrPlayer-leave-event', this.handleVRPlayerLeave);
    },
    watch: {
      // call again the method if the route changes
      '$route'(to, from) {
        this.$refs['videoPlayer'].close();
      },
    },
    methods: {
      handleHoverableClick(hoverable) {
        // debugger;
        EventBus.$emit('hoverable-close-modal');
        if (typeof hoverable !== 'undefined'
          && (!hoverable.disabled || hoverable.disabled === false)) {
          if (hoverable.linkTo) {
            // it will navigate to the route.
            // debugger;
            this.$router.push({ name: hoverable.linkTo, query: hoverable.query});
          }

          if (hoverable.appId) {
            // this will only works in Electron standalone mode
            // to open appdash application
            openApp(hoverable.appId, hoverable.url);
          }

          // No need to handle URL if AppId exists, AppID will handle url implicitly
          if (hoverable.url && !hoverable.appId) {
            // this will only works in browser mode
            // to open URL in new browser tab
            openURL(hoverable.url);
          }

          if (hoverable.video) {
            // play video in popup video player
            this.$refs['videoPlayer'].play(hoverable.video);
          }

          if (hoverable.vrVideo) {
            // play VR Video using VR-Player
            if(hoverable.onPage) {
              // Play directly on the page where it launches
              // this.$refs['vrPano'].hide();
              this.$refs['vrPlayer'].play(hoverable);
            } else {
              this.$router.push({name: 'VRPlayer', query: getVRPlayerQuery(hoverable)});
            }
          }

          if (hoverable.vrImage) {
            // show 360 Image using VR-Player
            if(hoverable.onPage) {
              this.$ref['vrPlayer'].showImage(hoverable); // disable video if playing
              // this.$refs['vrPano'].showImage(hoverable);
            }else{
              this.$router.push({name: 'VRPlayer', query: getVRPlayerQuery(hoverable)});
            }
          }

          if (hoverable.hasOwnProperty('gallery')) {
            // create an image gallery
            this.$refs['gallery'].show(hoverable.gallery);
          }

          if (hoverable.hasOwnProperty('pdf')) {
            // refer to pdfLauncher.js
            // to open pdf within appdash to launch another electron pdf viewer
            // or open a new tab in browser to view the pdf
            openPDF(hoverable.pdf);
          }
        }
      },
      handleVRPlayerLeave() {
        this.$refs['vrPlayer'].cleanUpAndHide();
        // this.$refs['vrPano'].cleanUpAndHide();
      },
    },
    data() {
      const name = window.configMgr.getConfig()['name'];
      const configJSON = window.configMgr.getConfig()['sideMenu'];
      configJSON.hoverableId = `${name}_hoverable`;
      return configJSON;
    },
  };

  function getVRPlayerQuery(hoverable){
    var vrPlayerParams = {};
    if (hoverable.hasOwnProperty('vrVideo')) {
      vrPlayerParams.vrVideo = hoverable.vrVideo;
    } else {
      vrPlayerParams.vrImage = hoverable.vrImage;
    }
    if (hoverable.hasOwnProperty('camera')) {
      vrPlayerParams.camera = hoverable.camera;
    }
    return flatten(vrPlayerParams);
  }


  // https://stackoverflow.com/questions/19098797/fastest-way-to-flatten-un-flatten-nested-json-objects
  function unflatten (data) {
    "use strict";
    if (Object(data) !== data || Array.isArray(data))
      return data;
    var regex = /\.?([^.\[\]]+)|\[(\d+)\]/g,
      resultholder = {};
    for (var p in data) {
      var cur = resultholder,
        prop = "",
        m;
      while (m = regex.exec(p)) {
        cur = cur[prop] || (cur[prop] = (m[2] ? [] : {}));
        prop = m[2] || m[1];
      }
      cur[prop] = data[p];
    }
    return resultholder[""] || resultholder;
  }

  // https://stackoverflow.com/questions/19098797/fastest-way-to-flatten-un-flatten-nested-json-objects
  // flatten json object
  function flatten (data) {
    var result = {};
    function recurse (cur, prop) {
      if (Object(cur) !== cur) {
        result[prop] = cur;
      } else if (Array.isArray(cur)) {
        for(var i=0, l=cur.length; i<l; i++)
          recurse(cur[i], prop + "[" + i + "]");
        if (l == 0)
          result[prop] = [];
      } else {
        var isEmpty = true;
        for (var p in cur) {
          isEmpty = false;
          recurse(cur[p], prop ? prop+"."+p : p);
        }
        if (isEmpty && prop)
          result[prop] = {};
      }
    }
    recurse(data, "");
    return result;
  }
</script>

<style lang="css" rel="stylesheet/css">
  @import "../assets/css/style.css";
  @import "../assets/css/vendor/animate.css";


  .main-wrapper {
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
  }

  .content-wrapper {
    width: 100%;
    height: 100%;
  }

  /**
  Pop up video player
  */
  .bg-mask {
    width: 100%;
    height: 100%;
    position: absolute;
    /* background-color: rgba(0,0,0,1); */
    background-color: black;
    z-index: 3;
    display: none;
  }

  .video_player {
    cursor: pointer;

  }

  .close-video-btn {
    background: url("../assets/images/close_normal.png") no-repeat;
    background-size: contain;
    position: absolute;
    cursor: pointer;
    display: none;
    /*width: 50px;*/
    width: 2.604%;
    top: 15px;
    /*right: 20px;*/
    right: 1.0416%;
    z-index: 5;
    background-size: contain;
  }

  .close-video-btn:hover {
    background: url("../assets/images/close_hover.png") no-repeat;
    background-size: contain;
  }
</style>




// WEBPACK FOOTER //
// TheMainContainer.vue?420ad94a